import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useSites from './useSites';
import { sitesService } from '../../_services/sites.service';
import { errorText, isLapsed, lapsedLine } from './addLocation/locationCopy';

/**
 * "Sort payment" for a location whose own plan lapsed. An unpaid invoice goes
 * to Stripe's page for it; a cancelled or expired plan runs the plan step for
 * that location (a new plan replaces the lapsed one). Returns an error string,
 * or null once it has navigated.
 */
export async function sortLocationPayment(history, site) {
    const r = await sitesService.sortLocationPayment(site.salonId);
    if (r && r.url) { window.location.assign(r.url); return null; }
    if (r && r.needsNewPlan) {
        await sitesService.saveLocationIntent({ existingSalonId: site.salonId });
        history.push(`/add-location/plan?existingSalonId=${encodeURIComponent(site.salonId)}`);
        return null;
    }
    return null;
}

/**
 * The nag for a lapsed location, shown in the nav while you are AT that
 * location, to the owner only. Gentle on purpose: nothing is locked and
 * clients' bookings carry on; it just keeps asking.
 */
export default function LocationBillingNag() {
    const history = useHistory();
    const { active, canAddLocation, refresh } = useSites();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    if (!active || !canAddLocation || !isLapsed(active)) return null;
    const onSort = async () => {
        if (busy) return;
        setBusy(true);
        setError('');
        try {
            await sortLocationPayment(history, active);
            refresh(true);
        } catch (e) {
            setError(errorText(e));
        }
        setBusy(false);
    };
    return (
        <div role="alert" style={{ margin: '0 12px 10px', padding: '10px 12px', borderRadius: 8, background: '#FFF4E5', color: '#8A4B00', fontSize: 12, lineHeight: 1.45 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>{lapsedLine(active.salonName)}</div>
            <button type="button" onClick={onSort} disabled={busy}
                style={{ border: 'none', borderRadius: 6, padding: '6px 10px', background: '#8A4B00', color: '#fff', fontSize: 12, fontWeight: 600, cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.7 : 1, fontFamily: 'inherit' }}>
                {busy ? 'Opening…' : 'Sort payment'}
            </button>
            {error ? <div style={{ marginTop: 6 }}>{error}</div> : null}
        </div>
    );
}
